import { WorkspacePrebidConfigurationDTO } from 'features/globalSetup/api/types/workspacePrebidConfiguration'
import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_WORKSPACE_PREBID_CONFIGURATION = (
  ability: Ability,
): TypedDocumentNode<Data, Variables> => gql`
  query getWorkspacePrebidConfiguration($workspaceId: ID!) {
    workspacePrebidConfiguration(workspaceId: $workspaceId) {
      ${permitFields<WorkspacePrebidConfigurationDTO['prebidVariableName']>({
        prebidVariableName: ability.can('read', 'GlobalSetupField-prebidVariableName'),
      })}

      allowActivitiesData
      auctionDelay
      disablePrebidStackForUsersWithPoorInternetEnabled
      gdprTcfEnabled
      gdprTcfTimeout
      gppControlUsNat
      gppControlUsStates
      gppEnabled
      gppTimeout
      id
      maximumRttToEnablePrebidStack
      prebidCustomConfig
      prebidTimeout
      s2sTimeoutMultiplier
      syncDelay
      syncsPerBidder
      usPrivacyCcpaEnabled
      usPrivacyCcpaTimeout
      videoPlayer
    }
  }
`
